import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';
import { Calendar, Users, Utensils, Award, Phone, Mail, ArrowRight } from 'lucide-react';

const Eventos = () => {
  const tiposEventos = [
    {
      icon: Users,
      titulo: 'Eventos Privados',
      descricao: 'Aniversários, casamentos, reuniões familiares e celebrações especiais',
      itens: ['Casamentos', 'Aniversários', 'Batizados', 'Reuniões']
    },
    {
      icon: Utensils,
      titulo: 'Eventos Corporativos',
      descricao: 'Eventos empresariais, lançamentos e confraternizações',
      itens: ['Lançamentos', 'Team Building', 'Confraternizações', 'Almoços']
    },
    {
      icon: Award,
      titulo: 'Catering Premium',
      descricao: 'Serviço completo de catering com churrasco premium',
      itens: ['Menu Personalizado', 'Churrasqueiro', 'Montagem', 'Atendimento']
    }
  ];

  return (
    <div className="min-h-screen bg-[#1a1a1a] pt-20">
      {/* Hero Section */}
      <section className="relative h-[50vh] flex items-center justify-center overflow-hidden">
        <div 
          className="absolute inset-0 z-0"
          style={{
            backgroundImage: 'url(https://images.unsplash.com/photo-1555939594-58d7cb561ad1?w=1920)',
            backgroundSize: 'cover',
            backgroundPosition: 'center'
          }}
        />
        <div className="absolute inset-0 z-0 bg-gradient-to-b from-[#1a1a1a]/80 via-[#1a1a1a]/60 to-[#1a1a1a]" />
        
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 z-10 text-center">
          <p className="text-[#B8860B] text-sm tracking-[0.3em] uppercase mb-4">Catering</p>
          <h1 className="text-5xl sm:text-6xl lg:text-7xl font-semibold text-[#E8DDCB] mb-6" style={{fontFamily: "'Playfair Display', serif"}}>
            Eventos
          </h1>
          <div className="w-16 h-[2px] bg-[#B8860B] mx-auto mb-6" />
          <p className="text-[#E8DDCB]/80 text-lg max-w-xl mx-auto">
            Fazemos eventos privados e comerciais
          </p>
        </div>
      </section>

      {/* Tipos de Eventos */}
      <section className="py-20 bg-[#1a1a1a]">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <p className="text-[#B8860B] text-sm tracking-[0.3em] uppercase mb-4">Serviços</p>
            <h2 className="text-4xl font-semibold text-[#E8DDCB]" style={{fontFamily: "'Playfair Display', serif"}}>
              Tipos de Eventos
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {tiposEventos.map((tipo, index) => {
              const Icon = tipo.icon;
              return (
                <Card key={index} className="bg-[#242424] border border-[#B8860B]/10 hover:border-[#B8860B]/40 transition-all">
                  <CardContent className="p-8 text-center">
                    <Icon className="w-12 h-12 text-[#B8860B] mx-auto mb-6" />
                    <h3 className="text-xl font-semibold text-[#E8DDCB] mb-4" style={{fontFamily: "'Playfair Display', serif"}}>
                      {tipo.titulo}
                    </h3>
                    <p className="text-[#E8DDCB]/60 text-sm mb-6">
                      {tipo.descricao}
                    </p>
                    <ul className="space-y-2">
                      {tipo.itens.map((item, i) => (
                        <li key={i} className="text-[#E8DDCB]/70 text-sm flex items-center justify-center">
                          <span className="w-1.5 h-1.5 bg-[#B8860B] rounded-full mr-2"></span>
                          {item}
                        </li>
                      ))}
                    </ul>
                  </CardContent>
                </Card>
              );
            })}
          </div>
        </div>
      </section>

      {/* O que oferecemos */}
      <section className="py-20 bg-[#242424]">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-4xl mx-auto">
            <div className="text-center mb-12">
              <p className="text-[#B8860B] text-sm tracking-[0.3em] uppercase mb-4">Incluído</p>
              <h2 className="text-4xl font-semibold text-[#E8DDCB]" style={{fontFamily: "'Playfair Display', serif"}}>
                O Que Oferecemos
              </h2>
            </div>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {[
                { title: 'Menu Personalizado', desc: 'Criamos um menu sob medida para o seu evento' },
                { title: 'Churrasqueiro Profissional', desc: 'Equipa experiente para garantir a perfeição' },
                { title: 'Equipamento Completo', desc: 'Levamos todo o equipamento necessário' },
                { title: 'Atendimento Premium', desc: 'Serviço de excelência do início ao fim' }
              ].map((item, i) => (
                <div key={i} className="p-6 border border-[#B8860B]/20 rounded-lg hover:border-[#B8860B]/50 transition-all">
                  <h3 className="text-lg font-semibold text-[#E8DDCB] mb-2" style={{fontFamily: "'Playfair Display', serif"}}>
                    {item.title}
                  </h3>
                  <p className="text-[#E8DDCB]/60 text-sm">{item.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-20 bg-[#1a1a1a]">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl mx-auto text-center space-y-8">
            <h2 className="text-4xl font-semibold text-[#E8DDCB]" style={{fontFamily: "'Playfair Display', serif"}}>
              Pronto para o seu Evento?
            </h2>
            <p className="text-[#E8DDCB]/70 text-lg">
              Entre em contacto e vamos criar uma experiência única.
            </p>
            
            <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
              <Button 
                asChild
                size="lg"
                className="bg-[#B8860B] hover:bg-[#D4A84B] text-[#1a1a1a] font-semibold tracking-wider uppercase text-sm px-8 py-6"
              >
                <Link to="/contacto">
                  <Mail className="w-4 h-4 mr-2" />
                  Solicitar Orçamento
                </Link>
              </Button>
              
              <a 
                href="tel:+351918288122"
                className="flex items-center space-x-2 text-[#E8DDCB]/80 hover:text-[#B8860B] transition-colors"
              >
                <Phone className="w-4 h-4 text-[#B8860B]" />
                <span className="font-medium">+351 918 288 122</span>
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Eventos;
